module.exports = __webpack_public_path__ + "img/ys_bj_2.ab5b38bd.png";